<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">Precio de Productos</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item active">PrecioProducto</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="card card-secondary card-outline">
      <div class="card-body">
          <div class="row">
              <div class="offset-sm-6 col-sm-6">
                  <div class="input-group">
                      <input type="search" v-model="txtBuscar" @keyup="listarProductos(1,txtBuscar)" class="form-control form-control-md" placeholder="Buscar por nombre">
                      <div class="input-group-append">
                          <button type="submit" class="btn btn-md btn-default">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                  </div>
              </div> 
          </div><br>
          <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-info">
                      <tr>
                          <th>Nombre</th>
                          <th>Descripción</th>
                          <th>Marca</th>
                          <th>Código SKU</th>
                          <th>Modelo</th>
                          <th>Serie</th>
                          <th>F.Venc</th>
                          <th>Precios de Venta</th>
                          <th>Add Precio</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="p in productos" :key="p.id">
                          <td v-text="p.nombre"></td>
                          <td v-text="p.descripcion"></td>
                          <td v-text="p.marca"></td>
                          <td>
                            <div v-if="p.codigoSku"><button class="btn btn-warning" @click="abrirModalSKU('updateSKU',p)">{{p.codigoSku}}</button></div>
                            <div v-else>
                                <button class="btn btn-sm btn-warning tooltip-btn" data-tooltip="Agregar Codigo SKU" @click="abrirModalSKU('addSKU',p)"
                            ><i class="fas fa-plus-square"></i></button>
                            </div>
                          </td>
                          <td v-text="p.modelo"></td>
                          <td v-text="p.serie"></td>
                          <td>{{fechaFormateada(p.fechaVencimiento)}}</td>
                          <td>
                            <div class="input-group" v-for="pre in p.precios" :key="pre.id">
                                <div class="input-group mb-1" >
                                <div class="input-group-prepend">
                                    <span class="input-group-text" style="font-size: 11pt;">{{pre.nombre_unidad_medida}} - {{ pre.tipoVenta }}</span>
                                </div>
                                <div class="input-group-append" @click="abrirModalPrecio('updatePrecio',p,pre)">
                                        <button class="btn btn-primary" type="button" style="font-size: 12pt;">S/ {{ pre.precio }}</button>
                                    </div>
                                </div>
                            </div>
                          </td>
                          <td>
                            <button class="btn btn-sm btn-info tooltip-btn" data-tooltip="Agregar precio" @click="abrirModalPrecio('addPrecio',p,'')"
                            ><i class="fas fa-plus-square"></i></button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
           <!-- Agrega el paginador aquí -->
          <div class="row">
              <div class="col-sm-6">
                  <span>Registros: {{ totalRegistros }}</span>
              </div>
              <div class="col-sm-6">
                  <ul class="pagination pagination-sm justify-content-end">
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToFirstPage" :disabled="isOnFirstPage">Primero</a>
                      </li>
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToPreviousPage" >Anterior</a>
                      </li>
                      <li class="page-item" :class="{ active: currentPage === page }" v-for="page in visiblePages" :key="page">
                          <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToNextPage" >Siguiente</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToLastPage" :disabled="isOnLastPage">Último</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>      

  </div><!-- /.card -->

      <!--- MODAL PRECIO --->
      <div v-if="showModalPrecio">
      <div class="modal">
          <div class="modal-overlay"></div>
              <div class="modal-content" v-on:keyup.enter = "accion === 'addPrecio' ? addPrecio() : updatePrecio()">
                  <div class="modal-header bg-primary text-white">
                      <h4>{{tituloModalPrecio}} S/</h4>
                      <button type="button" class="close" @click="cerrarModal()">&times;</button>
                  </div>
                  <div class="modal-body">
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Producto:</label>
                          <div class="col-sm-8">
                              <label for="" class="col-form-label">{{ producto }}</label>
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Modelo Serie:</label>
                          <div class="col-sm-8">
                              <label for="" class="col-form-label">{{ modeloseriefven }}</label>
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Unidad de venta:</label>
                          <div class="col-sm-8">
                              <select class="form-control" v-model="uniMedida">
                                <option :value="0">=== seleccione ===</option>
                                <option :value="uni.id" v-for="uni in arrayUniMedida" :key="uni.id">{{ uni.nombre }}</option>
                              </select>
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Tipo de Venta:</label>
                          <div class="col-sm-8">
                              <select class="form-control" v-model="tipoVenta">
                                <option value="POR MENOR">POR MENOR</option>
                                <option value="POR MAYOR">POR MAYOR</option>
                              </select>
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-4 col-form-label">Precio de venta S/:</label>
                          <div class="col-sm-8">
                              <input type="number" class="form-control" v-model="precioVenta" placeholder="0.0">
                          </div>
                      </div>
                
                  </div>
                    
                  <div class="container mb-2">
                    <div class="row">
                        <div class="col-md-6">
                            <button v-if="accion == 'updatePrecio' " type="button" class="btn btn-danger text-left" @click="eliminarPrecio()">Eliminar</button>
                        </div>
                        <div class="col-md-6 text-right">
                            <button type="button" class="btn btn-secondary" @click="cerrarModalPrecio()">Cerrar</button>&nbsp;
                            <button v-if="accion == 'addPrecio' " type="button" class="btn btn-primary" @click="addPrecio()">GUARDAR</button>
                            <button v-if="accion == 'updatePrecio' " type="button" class="btn btn-primary" @click="updatePrecio()">ACTUALIZAR</button>      
                        </div>
                    </div> 
                </div>
              </div>
          </div>
      </div>
  <!--- FIN MODAL PRECIO --->

  <!--- MODAL CODIGO SKU --->
  <div v-if="showModalSKU">
    <div class="modal">
        <div class="modal-overlay"></div>
            <div class="modal-content" v-on:keyup.enter = "addUpdateSKU()">
                <div class="modal-header bg-warning text-white">
                    <h4>{{tituloModalSKU}}</h4>
                    <button type="button" class="close" @click="cerrarModalSKU()">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="mb-3 row">
                        <label for="" class="col-sm-4 col-form-label">Producto:</label>
                        <div class="col-sm-8">
                            <label for="" class="col-form-label">{{ productoSKU }}</label>
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-4 col-form-label">Modelo:</label>
                        <div class="col-sm-8">
                            <label for="" class="col-form-label">{{ modelosku }}</label>
                        </div>
                    </div>            
                    <div class="mb-3 row">
                        <label for="" class="col-sm-4 col-form-label">Serie:</label>
                        <div class="col-sm-8">
                            <label for="" class="col-form-label">{{ seriesku }}</label>
                        </div>
                    </div>            
                    <div class="mb-3 row">
                        <label for="" class="col-sm-4 col-form-label">Fecha Vencimiento:</label>
                        <div class="col-sm-8">
                            <label for="" class="col-form-label">{{ fvsku }}</label>
                        </div>
                    </div>            
                    <div class="mb-3 row">
                        <label for="" class="col-sm-4 col-form-label">Código SKU:</label>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" v-model="codigoSku" placeholder="000A" style="text-transform:uppercase;">
                        </div>
                    </div>
                </div>
                <div class="container mb-2">
                  <div class="row">
                      <div class="col-md-6">
                          <button v-if="accion == 'updateSKU' " type="button" class="btn btn-danger text-left" @click="eliminarSKU()">Eliminar</button>
                      </div>
                      <div class="col-md-6 text-right">
                          <button type="button" class="btn btn-secondary" @click="cerrarModalSKU()">Cerrar</button>&nbsp;
                          <button v-if="accion == 'addSKU' " type="button" class="btn btn-primary" @click="addUpdateSKU()">GUARDAR</button>
                          <button v-if="accion == 'updateSKU' " type="button" class="btn btn-primary" @click="addUpdateSKU()">ACTUALIZAR</button>      
                      </div>
                  </div> 
              </div>
            </div>
        </div>
    </div>
<!--- FIN MODAL SKU --->
    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
        <span class="sr-only">Grabando...</span>
        </div>
        <p class="text-light mt-3">Procesando, espere...</p>
    </div>
</template>

<script>
    export default{
      data(){
          return{
              idPrecioProducto:'',
              nombre:'',
              unidadMedida:null,
              categoria:null,
              modeloseriefven:'',

              showModalPrecio: false,
              tituloModalPrecio: '',
              showModalSKU: false,
              tituloModalSKU: '',
              codigoSku:'',
              productos: [],
              categorias: [],
              marcas: [],
              arrayUniMedida:[],
              errorProducto:0,
              arrayMostMsj:[],
              errorSaveUpdate:[],
              tipoAccion: 0,
              txtBuscar:'',
              idEmpresa:'',
              uniMedida:0,
              tipoVenta:'POR MENOR',
              errorPrecio:0,
              idVarianteP:'',

              currentPage: 1,
              totalPages: 0,
              listporPage: 15, // coincide con el paginado DRF
              visiblePages: [], // Páginas visibles en el paginado
              totalPagesToShow: 5, // Cantidad de páginas visibles en el paginado
              totalRegistros:0,
              localeSocket:null,

              loading:false,
          }
      },
      computed: {
          isOnFirstPage() {
          return this.currentPage === 1;
          },
          isOnLastPage() {
          return this.currentPage === this.totalPages;
          },
      },
      methods:{
          updateVisiblePages() {
              const halfTotalPagesToShow = Math.floor(this.totalPagesToShow / 2);

              let startPage = Math.max(this.currentPage - halfTotalPagesToShow, 1);
              let endPage = Math.min(this.currentPage + halfTotalPagesToShow, this.totalPages);

              if (this.totalPages > this.totalPagesToShow) {
                  // Si el número de páginas es mayor que el total de páginas a mostrar, ajustamos los extremos
                  if (endPage === this.totalPages) {
                  startPage = Math.max(endPage - this.totalPagesToShow + 1, 1);
                  } else if (startPage === 1) {
                  endPage = Math.min(startPage + this.totalPagesToShow - 1, this.totalPages);
                  }
              }

              this.visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
          },
          goToPage(pageNumber) {
              // Cambiar la página actual al número de página seleccionado
              this.currentPage = pageNumber;
              // Llamar al método para obtener los datos de la página seleccionada
              this.listarProductos(pageNumber,'')
          },
          goToPreviousPage() {
              if (this.currentPage > 1) {
                  this.currentPage -= 1;
                  this.listarProductos(this.currentPage,'');
              }
          },
          goToNextPage() {
              if (this.currentPage < this.totalPages) {
                  this.currentPage += 1;
                  this.listarProductos(this.currentPage,'');
              }
          },
          goToFirstPage() {
              if (this.currentPage !== 1) {
                  this.currentPage = 1;
                  this.listarProductos(this.currentPage,'');
              }
          },

          goToLastPage() {
              if (this.currentPage !== this.totalPages) {
                  this.currentPage = this.totalPages;
                  this.listarProductos(this.currentPage,'');
              }
          },
          listarProductos(pageNumber,txtBuscar){
              let me = this
              this.$axios.get(`apinventario/varianteproducto/?page=${pageNumber}&search=${txtBuscar}&idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                  me.productos = response.data.results
                  me.currentPage = pageNumber
                  me.totalPages = Math.ceil(response.data.count / me.listporPage)
                  me.totalRegistros = response.data.count
                  me.updateVisiblePages()
              })

          },
          validarProducto(){
              this.errorProducto = 0
              this.arrayMostMsj = []
              if(!this.categoria) this.arrayMostMsj.push("Seleccione una categoria")
              if(!this.nombre.trim()) this.arrayMostMsj.push("Ingrese el nombre del producto")
              if(this.arrayMostMsj.length) this.errorProducto = 1
              return this.errorProducto
          },
          registrarProducto(){
              if(this.validarProducto()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.post(`apinventario/productos/`, {
                  nombre: (me.nombre.toUpperCase()).trim(),
                  unidadMedida: me.unidadMedida,
                  descripcion: (me.descripcion.toUpperCase()).trim(),
                  tieneModelo: me.modelo,
                  tieneSerie: me.serie,
                  tieneVencimiento: me.fvencimiento,
                  idCategoria: me.categoria,
                  idMarca: me.marca,
                  idEmpresa: me.idEmpresa,
              })
              .then(function (response) {
                  me.listarProductos(1,'')
                  me.cerrarModal()
                  console.log(response)
                  me.$toastr.success('Nuevo producto registrado', 'Registrado');
                  me.$socket.send(JSON.stringify({
                    'message': 'nuevo producto'
                  }))
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                    if(error.response.data.codigo){me.errorSaveUpdate.push(error.response.data.codigo[0])}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          actualizarProducto(){
              if(this.validarProducto()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.patch(`apinventario/productos/`+me.id+`/`,{
                  nombre: (me.nombre.toUpperCase()).trim(),
                  descripcion: (me.descripcion.toUpperCase()).trim(),
                  tieneModelo: me.modelo,
                  tieneSerie: me.serie,
                  tieneVencimiento: me.fvencimiento,
                  idCategoria: me.categoria,
                  idMarca: me.marca,
              })
              .then(function(response){
                  console.log(response)
                  me.listarProductos(me.currentPage,me.txtBuscar)
                  me.cerrarModal()
                  me.$toastr.success('Producto actualizado', 'Actualizado');
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                    if(error.response.data.codigo){me.errorSaveUpdate.push(error.response.data.codigo)}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          eliminarProducto(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text: activo ? 'Presione Si para eliminar' : 'Presione Si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo ? 'Eliminar' : 'Restaurar',
              }).then((result) => {
                me.loading=true
              if (result.isConfirmed) {
                  this.$axios.patch(`apinventario/productos/`+id+`/`,{
                    activo : activo ?  0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarProductos(me.currentPage,me.txtBuscar)
                      me.cerrarModal()
                      if(activo){me.$toastr.success('Producto deshabilitado', 'Desactivado')}
                      else{me.$toastr.success('Producto Habilitado', 'Habilitado')}
                  })
                  .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
              }else{me.loading=false}
              })
          },
          listarUnidadMedida(){
          let me = this
            this.$axios.get(`apinventario/unidadmedidall/`)
            .then(function(response){
              const arrayfilter = response.data.filter(element => element.activo == 1)
              me.arrayUniMedida = arrayfilter
            })          
        },
          abrirModalPrecio(accion,data=[],dato=[]){
            this.showModalPrecio=true
            this.listarUnidadMedida()
            this.id = data.id
            this.accion = accion
            switch(accion){
                case 'addPrecio':{
                    this.tituloModalPrecio = 'Agregar Precio de Venta'
                    this.producto = `${data.nombre} ${data.marca?data.marca:' '} ${data.descripcion?data.descripcion:''}`
                    this.idVarianteP=data.id
                    this.modeloseriefven = `${data.modelo?`Modelo: ${data.modelo}`:''} ${data.serie?`Serie: ${data.serie}`:''} ${data.fechaVencimiento?`F.V ${this.fechaFormateada(data.fechaVencimiento)}`:''}`
                    break
                }
                case 'updatePrecio':{
                    console.log(data)
                    this.tituloModalPrecio = 'Actualizar precio de venta'
                    this.producto = `${data.nombre} ${data.marca?data.marca:' '} ${data.descripcion?data.descripcion:''}`
                    this.modeloseriefven = `${data.modelo?`Modelo: ${data.modelo}`:''} ${data.serie?`Serie: ${data.serie}`:''} ${data.fechaVencimiento?`F.V ${this.fechaFormateada(data.fechaVencimiento)}`:''}`
                    this.precioVenta = dato.precio
                    this.uniMedida = dato.idUnidadMedida
                    this.tipoVenta=dato.tipoVenta
                    this.idPrecioProducto = dato.id
                    this.idVarianteP=dato.idVarianteP
                    break
                }
            }      
                            
        },
        fechaFormateada(fecha) {
            if(fecha != '' && fecha){
                const partes = fecha.split('-')
                return `${partes[2]}/${partes[1]}/${partes[0]}`
            }else return ''
            
        },
        validarPrecio(){
            this.errorPrecio = 0
            this.arrayMostMsj = []
            const numerosExp = /^\d*\.?\d*$/
            if(!numerosExp.test(this.precioVenta) || this.precioVenta === '') this.arrayMostMsj.push("El precio de venta debe ser numero positivo")
            if(this.uniMedida == 0) this.arrayMostMsj.push('Seleccione unidad de venta')
            if(this.arrayMostMsj.length) this.errorPrecio = 1
            return this.errorPrecio
        },
        addPrecio(){
            if(this.validarPrecio()){
                this.arrayMostMsj.forEach(element => {
                    this.$toastr.error(element,'Atencion')
                });
                return
            }
            let me = this
            me.loading=true
              this.$axios.post(`apinventario/precioproducto/`, {
                idVarianteP: me.idVarianteP,
                idUnidadMedida: me.uniMedida,
                tipoVenta: me.tipoVenta,
                precio: me.precioVenta,
            })
            .then(function (response) {
                me.listarProductos(me.pageNumber = 1,me.txtBuscar)
                me.cerrarModalPrecio()
                console.log(response)
                me.$toastr.success('Precio agregado', 'Registrado');
            })
            .catch(function (error) {
                me.$toastr.error('Error al guardar precio', 'Error')
                console.log(error)    
            })
            .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
        },
        updatePrecio(){
            if(this.validarPrecio()){
                this.arrayMostMsj.forEach(element => {
                    this.$toastr.error(element,'Atencion')
                });
                return
            }
            let me = this
            me.loading=true          
            this.$axios.patch(`apinventario/precioproducto/`+me.idPrecioProducto+`/`,{
                precio: me.precioVenta,
                idUnidadMedida: me.uniMedida,
                tipoVenta: me.tipoVenta,
            }).
            then(function(response){
                me.listarProductos(me.pageNumber = 1,me.txtBuscar)
                me.cerrarModalPrecio()
                me.$toastr.success('Precio actualizado','Actualizado')
                console.log(response)
            }).
            catch(function(error){
                me.$toastr.error('Error al actualizar','Error')
                console.log(error)
            })
            .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
        },
        eliminarPrecio(){
            let me = this
            me.loading=true
            this.$axios.delete(`apinventario/precioproducto/`+me.idPrecioProducto+`/`).
            then(function(response){
                me.listarProductos(me.pageNumber = 1,me.txtBuscar)
                me.cerrarModalPrecio()
                me.$toastr.success('Precio eliminado','Borrado')
                console.log(response)
            }).
            catch(function(error){
                me.$toastr.error('Error al borrar','Error')
                console.log(error)
            })
            .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
        },
          cerrarModalPrecio(){
              this.showModalPrecio = false;
              this.id = ''
              this.idVarianteP=''
              this.tipoVenta = 'POR MENOR'
              this.uniMedida=0
              this.precioVenta=''
              this.categorias=[]
              this.marcas=[]
              this.idPrecioProducto=''
          },
          validarSKU(){
            this.errorSKU = 0
            this.arrayMostMsjSKU = []
            if(this.codigoSku.trim() == '') this.arrayMostMsjSKU.push('Ingrese un Código SKU')
            if(this.arrayMostMsjSKU.length) this.errorSKU = 1
            return this.errorSKU
        },
        addUpdateSKU(){
            if(this.validarSKU()){
                this.arrayMostMsjSKU.forEach(element => {
                    this.$toastr.error(element,'Atencion')
                });
                return
            }
            let me = this
            me.loading=true
              this.$axios.patch(`apinventario/varianteproducto/${this.idVarianteP}/`, {
                codigoSku: (me.codigoSku.toUpperCase()).trim(),
            })
            .then(function (response) {
                me.listarProductos(me.currentPage,me.txtBuscar)
                me.cerrarModalSKU()
                console.log(response)
                me.$toastr.success('Código Actualizado', 'Actualizado');
            })
            .catch(function (error) {
                let mensajes = [];
                if (error.response && error.response.data) {
                    const data = error.response.data;
                    Object.keys(data).forEach(campo => { // Recorre cada campo con error
                        const erroresCampo = data[campo];
                        if (Array.isArray(erroresCampo)) { // Puede ser array, objeto o string
                            erroresCampo.forEach(err => {
                                if (typeof err === "object" && err.string) {
                                    mensajes.push(err.string);  // Django REST ErrorDetail
                                } else {
                                    mensajes.push(err);         // string común
                                }
                            });
                        } else if (typeof erroresCampo === "object" && erroresCampo.string) {
                            mensajes.push(erroresCampo.string);
                        } else {
                            mensajes.push(erroresCampo);
                        }
                    });
                } else {
                    mensajes.push("Error inesperado.");
                }

// Mostrar los errores en toastr
mensajes.forEach(msg => {
    me.$toastr.error(msg, "Error");
});

console.log("Errores backend:", mensajes);
            })
            .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
        },
        eliminarSKU(){
            let me = this
            me.loading=true
            this.$axios.patch(`apinventario/varianteproducto/${this.idVarianteP}/`, {
                codigoSku: null,
            }).
            then(function(response){
                me.listarProductos(me.currentPage,me.txtBuscar)
                me.cerrarModalSKU()
                me.$toastr.success('Codigo eliminado','Borrado')
                console.log(response)
            }).
            catch(function(error){
                if (error.response && error.response.data) {
                    let errores = error.response.data;
                    // Recorremos los campos del error
                    for (let campo in errores) {
                        if (Array.isArray(errores[campo])) {
                            errores[campo].forEach(msg => {
                                me.$toastr.error(msg, 'Error')
                            });
                        } else {
                            me.$toastr.error(errores[campo], 'Error')
                        }
                    }
                } else {
                    me.$toastr.error('Ocurrió un error inesperado', 'Error')
                }
                console.log(error)
            })
            .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
        },
          abrirModalSKU(accion,data=[]){
            this.showModalSKU=true
            this.accion = accion
            switch(accion){
                case 'addSKU':{
                    this.tituloModalSKU = 'Agregar Código SKU'
                    this.productoSKU = `${data.nombre} ${data.descripcion?data.descripcion:''}`
                    this.idVarianteP=data.id
                    this.modelosku = `${data.modelo?data.modelo:'Sin Modelo'}`
                    this.seriesku =  `${data.serie?data.serie:'Sin Serie'}`
                    this.fvsku =   `${data.fechaVencimiento?this.fechaFormateada(data.fechaVencimiento):'Sin Fecha de Vencimiento'}`
                    break
                }
                case 'updateSKU':{
                    
                    console.log(data)
                    this.tituloModalSKU = 'Actualizar Código SKU'
                    this.productoSKU = data.nombre+' '+(data.descripcion?+'-'+data.descripcion:'')
                    this.modelosku = `${data.modelo?data.modelo:'Sin Modelo'}`
                    this.seriesku =  `${data.serie?data.serie:'Sin Serie'}`
                    this.fvsku =   `${data.fechaVencimiento?this.fechaFormateada(data.fechaVencimiento):'Sin Fecha de Vencimiento'}`
                    this.codigoSku = data.codigoSku
                    this.idVarianteP=data.id
                    break
                }
            }         
        },
        cerrarModalSKU(){
              this.showModalSKU = false;
              this.idSKU = ''
              this.idVarianteP=''
              this.codigoSku=''
          },
      },
          
      watch: {
          currentPage() {
          // Actualizar las páginas visibles cuando se cambia la página actual
          this.updateVisiblePages();
          },
          totalPages() {
          // Actualizar las páginas visibles cuando se actualiza el número total de páginas
          this.updateVisiblePages();
          },
      },
      mounted(){
          this.idEmpresa = localStorage.getItem('idEmpresa')
          this.listarProductos(1,'')
          this.updateVisiblePages()
          
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
/* Estilo base del botón */
.tooltip-btn {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* Estilo del tooltip */
.tooltip-btn::before {
  content: attr(data-tooltip);
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  padding: 5px 10px;
  
  white-space: nowrap;
  border-radius: 4px;
  top: 50%; /* Ajusta la posición vertical según tus necesidades */
  left: 100%;
  transform: translateY(-50%);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}
/* Mostrar el tooltip al hacer hover */
.tooltip-btn:hover::before {
  opacity: 1;
  visibility: visible;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>